import React from 'react';

import { SxProps, Theme } from '@mui/material';

import { ActiveDot, FormLabel } from '../components';
import Box from '../components/box/box';

type withTitleProps = {
  label?: string;
  required?: boolean;
  active?: boolean;
  labelSx?: SxProps<Theme>;
};

function withTitle<T extends React.ComponentType<any>>(WrappedComponent: T) {
  return ({
    label,
    required,
    active,
    labelSx,
    variant = 'outlined',
    ...props
  }: withTitleProps &
    React.ComponentPropsWithoutRef<T> & {
      variant?: 'outlined' | 'filled' | 'standard';
    }) => {
    return (
      <Box
        display={'flex'}
        flexDirection={'column'}
        gap={2}
        style={{ width: '100%' }}
      >
        {!!label && (
          <FormLabel sx={labelSx}>
            <Box display="flex" alignItems="center" gap={1}>
              {label}
              {required && <span style={{ color: 'red' }}> * </span>}
              {active && <ActiveDot />}
            </Box>
          </FormLabel>
        )}
        <WrappedComponent {...(props as React.ComponentProps<T>)} />
      </Box>
    );
  };
}

export { withTitleProps, withTitle };
